import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

export const startCourseLineItems = data => {
  const root = createRoot(document.getElementById('course_line_items'))
  root.render(
    <App
      coursenum={data.coursenum}
      initialLineItems={data.lineItems}
      catalog={data.catalog}
      initialCourseFee={data.courseFee}
    />
  )
}
